module.exports = __webpack_public_path__ + "img/029-storm-15.21dc5741.svg";